import React, { useEffect, useState } from 'react';

import axios from 'axios';

import { makeStyles } from '@material-ui/core/styles';
import { Button, Collapse, TextField, Typography } from '@material-ui/core';

import laptop from '../../assets/laptop-meetcaster.png';

const useStyles = makeStyles((theme) => ({
    // [theme.breakpoints.up('xs')]: {}
    // [theme.breakpoints.up('sm')]: {}
    // [theme.breakpoints.up('md')]: {}
    // [theme.breakpoints.up('xl)]: {}
    root: {
        padding: theme.spacing(4),
        backgroundColor: theme.palette.common.white,
        [theme.breakpoints.up('xs')]: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        },
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    header: {
        fontWeight: 300,
    },
    nanoMeet: {
        color: theme.palette.primary.main,
        fontWeight: 700
    },
    textWrapper: {
        [theme.breakpoints.up('xs')]: {
            textAlign: 'center',
            maxWidth: '100%'

        },
        [theme.breakpoints.up('md')]: {
            textAlign: 'left'
        },
    },
    button: {
        color: theme.palette.common.white,
        marginTop: theme.spacing(1)
    },
    image: {
        [theme.breakpoints.up('xs')]: {
            width: 400,
            maxWidth: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: 700
        },
    },
    imageWrapper: {
        [theme.breakpoints.up('xs')]: {
            marginTop: theme.spacing(2)
        },
        [theme.breakpoints.up('md')]: {
            marginTop: 0
        },
    },
    contactWrapper: {
        marginTop: theme.spacing(2)
    },
    textfield: {
        marginTop: theme.spacing(0.5)
    },
    response: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        borderRadius: theme.spacing(1),
        color: theme.palette.common.white
    },
    title: {
        fontWeight: 700
    },
    description: {
        fontWeight: 300
    }
}))

export default function Demo(props) {
    const classes = useStyles();
    const [collapseContact, setCollapseContact] = useState(false);
    const button = document.getElementById("_form_41_submit");
    const [name, setName] = useState("");
    const [success, setSuccess] = useState(false);

    const collapse = () => {
        if (window.gtag) {
            window.gtag('event', 'nanomeet_demo_requested', {
                'event_callback': () => {
                    setCollapseContact(!collapseContact);
                }
            })
        }
    }

    if (button) {
        button.addEventListener("click", () => {
            let fullName = document.getElementsByName("fullname")[0].value;
            setName(fullName);
            window.gtag('event', 'nanomeet_demo', {
                'event_callback': () => {
                    setSuccess(true);
                }
            })
        })
    }

    useEffect(() => {
        if (props.start) {
            collapse();
        }
    }, [props.start])

    return (
        <div className="root" className={classes.root}>
            <div className={classes.textWrapper}>
                <Typography className={classes.header} variant="h4">
                    Book a free <span className={classes.nanoMeet}>nanoMeet</span> demo today!
                </Typography>
                <Collapse in={!collapseContact}>
                    <Button onClick={collapse} size="large" variant="contained" color="primary" className={classes.button}>
                        Start now
                    </Button>
                </Collapse>
                <Collapse in={collapseContact}>
                <div className={classes.form} className="_form_41"></div>
                </Collapse>
            </div>
            <div className={classes.imageWrapper}>
                <img className={classes.image} src={laptop} />
            </div>
        </div>
    )
}